import {observable, makeObservable} from "mobx";
import {BaseModel} from "../../../infrastructure/models/base-model";
import {LOCAL_STORAGE_KEYS} from "../../../core/consts";
import {ENTITY_DESCRIPTION} from "../../../modules/entity-description-module/entity-description.module.consts";
import {SessionStorageUtils} from "../../../infrastructure/utils/session-storage.utils";

export class EntityDescriptionRemoteConfigModel extends BaseModel {
  @observable display: Boolean;
  @observable languageIds: Array<Number>;
  @observable sportTypeIds: Array<Number>;
  @observable competitionIds: Array<Number>;
  @observable competitorIds: Array<Number>;
  @observable entityTypes: Array<Number>;
  @observable userCountryIds: Array<Number>;

  constructor(model: Object, sessionStorageUtils: SessionStorageUtils) {
    super();

    this.display = sessionStorageUtils.get(LOCAL_STORAGE_KEYS.entityDescriptionDisplay) || (model?.display === true);
    this.languageIds = sessionStorageUtils.get(LOCAL_STORAGE_KEYS.entityDescriptionLanguagesIds)?.split(",").map(id => parseInt(id)) || model?.languageIds || [];
    this.sportTypeIds = sessionStorageUtils.get(LOCAL_STORAGE_KEYS.entityDescriptionSportTypeIds)?.split(",").map(id => parseInt(id)) || model?.sportTypeIds || [];
    this.competitionIds = sessionStorageUtils.get(LOCAL_STORAGE_KEYS.entityDescriptionCompetitionIds)?.split(",").map(id => parseInt(id)) || model?.competitionIds || [];
    this.competitorIds = sessionStorageUtils.get(LOCAL_STORAGE_KEYS.entityDescriptionCompetitorIds)?.split(",").map(id => parseInt(id)) || model?.competitorIds || [];
    this.entityTypes = sessionStorageUtils.get(LOCAL_STORAGE_KEYS.entityDescriptionEntityTypes)?.split(",").map(id => parseInt(id)) || model?.entityTypes || [];
    this.userCountryIds = sessionStorageUtils.get(LOCAL_STORAGE_KEYS.entityDescriptionUserCountryIds)?.split(",").map(id => parseInt(id)) || model?.userCountryIds || [];

    makeObservable(this);
  }

  isValid(sportTypeId: Number, competitionId: Number, competitorId: Number, languageId: Number, userCountryId: Number, entityType: Number) {
    const isCurrentLanguage: Boolean = Object.values(this.languageIds).includes(languageId);
    const isCurrentUserCountryId: Boolean = Object.values(this.userCountryIds).includes(userCountryId);
    const isValidEntityId = this.validByEntityType(entityType, sportTypeId, competitionId, competitorId);
    const isVisible: Boolean = this.display && isCurrentLanguage && isCurrentUserCountryId && isValidEntityId;

    return isVisible;
  }

  validByEntityType(entityType, sportTypeId, competitionId, competitorId) {
    let isValid = false;
    const isEntityValid = entityType >= 0 && Object.values(this.entityTypes).includes(entityType);

    switch (entityType) {
      case ENTITY_DESCRIPTION.ENTITY_TYPE.sport: {
        isValid = isEntityValid && Object.values(this.sportTypeIds).includes(sportTypeId);
        break;
      }
      case ENTITY_DESCRIPTION.ENTITY_TYPE.competition: {
        isValid = isEntityValid && Object.values(this.competitionIds).includes(competitionId);
        break;
      }
      case ENTITY_DESCRIPTION.ENTITY_TYPE.competitor: {
        isValid = isEntityValid && Object.values(this.competitorIds).includes(competitorId);
        break;
      }
      case ENTITY_DESCRIPTION.ENTITY_TYPE.preMatch: {
        isValid = isEntityValid && Object.values(this.sportTypeIds).includes(sportTypeId);
        break;
      }
      case ENTITY_DESCRIPTION.ENTITY_TYPE.postMatch: {
        isValid = isEntityValid && Object.values(this.sportTypeIds).includes(sportTypeId);
        break;
      }
      default:
        isValid = false;
        break;
    }

    return isValid;
  }
}
